var divider_viewer_rtlignore_default = {
  "divider-container": "WGvU9",
  "divider-container--double": "Nj96C",
  "divider": "JtlEl",
  "divider--single": "-rEBk",
  "divider--double": "YeuNS",
  "divider--dashed": "ngP-7",
  "divider--dotted": "_3-288",
  "divider--small": "zhF1v",
  "divider--medium": "sw-Mj",
  "divider--large": "jK9nA",
  "divider--left": "sSyaJ",
  "divider--center": "ZmWTU",
  "divider--right": "nLsVc",
  "svgFixerContainer": "r8VCZ",
  "emptyChar": "dNRFL"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
